import { atom } from "jotai";

export type CognitoUserAttributes = {
  username?: string;
  userId?: string;
};

export const userAtom = atom<CognitoUserAttributes | null>(null);
export const userLoadingAtom = atom<boolean>(true);
